/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import React from "react";
import { SelectProps, Typography, FormLabel } from "@mui/material";
import { RadioYesNo, RadioYesNoSmall, RadioGroupBasic } from "components/common/form";
import { InputDatePicker } from "components/common/form/input/input-date-picker";
import AddressGroup from "components/common/form/address-group";
import { Column, FormRow } from "components/common/html";
import { unitSizeMetadata } from "model/interest/unit-size";

import {
  isFieldInSchema,
  getLabelFromSchema,
  gatherAllHouseholdMembers,
  ShouldRenderField,
  // thin wrapper components to clean up duplication
  Input,
  Checkbox as NormalCheckbox,
  Select,
  SelectAutocomplete,
  getUnitSizeOptions,
  capitalize,
} from "pages/dashboard/interests-form/interest-form-utils";
import { languages } from "../utils";

const styles = {
  sectionBtn: {
    marginRight: 10,
  },
} as const;


const Checkbox = (props: any) => <NormalCheckbox size="small" {...props} />;

const InterestForm:React.FC<{
  formData: any,
  handleChangeHousehold?: SelectProps["onChange"],
  validationSchema: any[],
}> =
(props) => {
  // keep track of what fields are showing after pressing 'add asset'
  const [state, setState] = React.useState<any>({
    householdMember0NetSelfIncomeInc: 0,
    householdMember1NetSelfIncomeInc: 0,
    householdMember2NetSelfIncomeInc: 0,
    householdMember3NetSelfIncomeInc: 0,
    householdMember4NetSelfIncomeInc: 0,
    householdMember5NetSelfIncomeInc: 0,
    householdMember0IncomeNotlistInc: 0,
    householdMember1IncomeNotlistInc: 0,
    householdMember2IncomeNotlistInc: 0,
    householdMember3IncomeNotlistInc: 0,
    householdMember4IncomeNotlistInc: 0,
    householdMember5IncomeNotlistInc: 0,
    householdMember0EmployerInc: 0,
    householdMember1EmployerInc: 0,
    householdMember2EmployerInc: 0,
    householdMember3EmployerInc: 0,
    householdMember4EmployerInc: 0,
    householdMember5EmployerInc: 0,
    // assets
    householdMember0CheckingInc: 0,
    householdMember1CheckingInc: 0,
    householdMember2CheckingInc: 0,
    householdMember3CheckingInc: 0,
    householdMember4CheckingInc: 0,
    householdMember5CheckingInc: 0,
    householdMember0SavingsInc: 0,
    householdMember1SavingsInc: 0,
    householdMember2SavingsInc: 0,
    householdMember3SavingsInc: 0,
    householdMember4SavingsInc: 0,
    householdMember5SavingsInc: 0,
    householdMember0AssetNotlistInc: 0,
    householdMember1AssetNotlistInc: 0,
    householdMember2AssetNotlistInc: 0,
    householdMember3AssetNotlistInc: 0,
    householdMember4AssetNotlistInc: 0,
    householdMember5AssetNotlistInc: 0,
    mailingAddressType: props.formData.mailingAddressType,
    householdMember0CitizenIdType: props.formData.householdMember0CitizenIdType,
    householdMember1CitizenIdType: props.formData.householdMember1CitizenIdType,
    householdMember2CitizenIdType: props.formData.householdMember2CitizenIdType,
    householdMember3CitizenIdType: props.formData.householdMember3CitizenIdType,
    householdMember4CitizenIdType: props.formData.householdMember4CitizenIdType,
    householdMember5CitizenIdType: props.formData.householdMember5CitizenIdType,
    householdMember0Gender: props.formData.householdMember0Gender,
    householdMember1Gender: props.formData.householdMember1Gender,
    householdMember2Gender: props.formData.householdMember2Gender,
    householdMember3Gender: props.formData.householdMember3Gender,
    householdMember4Gender: props.formData.householdMember4Gender,
    householdMember5Gender: props.formData.householdMember5Gender,
  });
  const members = gatherAllHouseholdMembers(props.formData);
  const { formData, validationSchema } = props;
  const schema = props.validationSchema;

  return (
    <>
      <div
        id="navContainer"
        style={{
          height: 50,
          paddingTop: 14,
          paddingBottom: 10,
          paddingLeft: 16,
          paddingRight: 16,
          background: "white",
          zIndex: 100,
          position: "sticky",
          top: "0",
          borderBottom: "1px solid #ebebeb",
          overflowX: "auto",
          overflowY: "hidden",
        }}
      >
        <b style={styles.sectionBtn}>
          <a href="#householdmembers">Household</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#address">Address</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#income">Income</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#assets">Asset</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#housing">Housing</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#contact">Contact</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#race">Race</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#additional">Additional</a>
        </b>
      </div>
      <div style={{ padding: 16 }}>
        {isFieldInSchema("prefLang", validationSchema) && (
          <FormRow>
            <RadioGroupBasic
              label="Preferred Language"
              name="prefLang"
              options={languages.map(({ code, enName, nativeName }) => ({
                label: `${enName} ${nativeName ? ` - ${nativeName}` : ""}`,
                value: code,
              }))}
              defaultValue={formData.prefLang}
            />
          </FormRow>
        )}

        <FormRow><Typography variant="h5" id="householdmembers">Household Info</Typography></FormRow>

        {props.handleChangeHousehold ? (
          <ShouldRenderField name="householdCount" vs={schema}>
            <FormRow>
              <Column width={12}>
                <Typography variant="body2">
                  How many people will live in the apartment, including yourself?
                </Typography>
              </Column>
              <Select
                width={2}
                label="Household Size"
                name="householdCount"
                formData={props.formData}
                options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                onChange={props.handleChangeHousehold}
              />
            </FormRow>
          </ShouldRenderField>) : (<div style={{ display: "none" }}>
          {/* hidden fields used for form parsing */}
          <Input name="householdCount" formData={props.formData} />
          <Input name="submittedAt" formData={props.formData} />
          <RadioYesNo label="" name="isComplete" formData={props.formData} />
          <RadioYesNo label="" name="manuallyEntered" formData={props.formData} />
        </div>)}

        {members.map((_member, i) => (
          <div key={i} style={{ marginTop: 4 }}>
            {/* only show heading if we are requesting at least a first name */}
            <ShouldRenderField name={`householdMember${i}FirstName`} vs={schema}>
              <Typography variant="h6">Household Member {i + 1}</Typography>
            </ShouldRenderField>

            <FormRow>
              {isFieldInSchema(`householdMember${i}FirstName`, validationSchema) && (
                <Column width={6} sm={6}>
                  <Input
                    label="First Name"
                    name={`householdMember${i}FirstName`}
                    formData={props.formData}
                  />
                </Column>
              )}
              {i === 0 && isFieldInSchema(`householdMember${i}MiddleName`, validationSchema) && (
                <Column width={6} sm={6}>
                  <Input
                    label="Middle Name"
                    name={`householdMember${i}MiddleName`}
                    formData={props.formData}
                  />
                </Column>
              )}
              {isFieldInSchema(`householdMember${i}LastName`, validationSchema) && (
                <Column width={6} sm={6}>
                  <Input
                    label="Last Name"
                    name={`householdMember${i}LastName`}
                    formData={props.formData}
                  />
                </Column>
              )}
              {isFieldInSchema(`householdMember${i}RelationToApp`, validationSchema) &&
                  i > 0 && (
                <Select
                  width={4}
                  label="Relationship to Head of Household"
                  name={`householdMember${i}RelationToApp`}
                  formData={props.formData}
                  options={[
                    { label: "Head of Household", value: "Head of Household", disabled: true },
                    { label: "Co-head/Spouse", value: "Co-head/Spouse" },
                    { label: "Domestic Partner", value: "Domestic Partner" },
                    { label: "Significant Other", value: "Significant Other" },
                    { label: "Foster Child", value: "Foster Child" },
                    { label: "Dependent Child", value: "Dependent Child" },
                    { label: "Unborn Child", value: "Unborn Child" },
                    { label: "Child (18+)", value: "Child (18+)" },
                    { label: "Child to be Adopted", value: "Child to be Adopted" },
                    { label: "Expectant Child of House Member", value: "Expectant Child of House Member" },
                    { label: "Parent", value: "Parent" },
                    { label: "Sibling", value: "Sibling" },
                    { label: "Cousin", value: "Cousin" },
                    { label: "Aunt", value: "Aunt" },
                    { label: "Uncle", value: "Uncle" },
                    { label: "Nephew", value: "Nephew" },
                    { label: "Niece", value: "Niece" },
                    { label: "Grandparent", value: "Grandparent" },
                    { label: "Great Grandparent", value: "Great Grandparent" },
                    { label: "In-law", value: "In-law" },
                    { label: "Friend", value: "Friend" },
                    { label: "Live in Caregiver", value: "Live in Caregiver" },
                    { label: "Other Family Member", value: "Other Family Member" },
                    { label: "Other", value: "Other" },
                  ]}
                />
              )}

              {isFieldInSchema(`householdMember${i}Gender`, validationSchema) && (
                <>
                  <Select
                    width={4}
                    margin="dense"
                    label="Gender"
                    name={`householdMember${i}Gender`}
                    formData={props.formData}
                    options={[
                      { label: "Male", value: "male" },
                      { label: "Female", value: "female" },
                      { label: "Trans", value: "trans" },
                      { label: "Non-Binary", value: "nonbinary" },
                      { label: "Other", value: "other" },
                    ]}
                    onChangeAction={(_selector: any, e: any) => {
                      setState((oldState: any) => ({
                        ...oldState,
                        [`householdMember${i}Gender`]: e.target.value,
                      }));
                    }}
                  />
                  {["trans", "nonbinary", "other"].includes(
                    state[`householdMember${i}Gender`],
                  ) && (
                    <Column width={6}>
                      {(() => {
                        const pronounOptions = [
                          { label: "She/her", value: "she_her" },
                          { label: "He/him", value: "he_him" },
                          { label: "They/them", value: "they_them" },
                          { label: "Other", value: "other" },
                        ];
                        const fieldName = `householdMember${i}GenderPronoun`;
                        return (
                          <SelectAutocomplete
                            label="What pronouns do you prefer?"
                            name={fieldName}
                            formData={props.formData}
                            options={pronounOptions}
                            width={6}
                            freeSolo
                          />
                        );
                      })()}
                    </Column>
                  )}
                </>
              )}

              {isFieldInSchema(`householdMember${i}Dob`, validationSchema) && (
                <>
                  <Column width={4}>
                    <InputDatePicker
                      label="Date of Birth"
                      placeholder="MM/DD/YYYY"
                      name={`householdMember${i}Dob`}
                      width={5}
                      formData={props.formData}
                    />
                  </Column>
                  {i > 0 && (
                    <Column width={6}>
                      <Checkbox
                        label="Unborn child, no date of birth yet"
                        name={`householdMember${i}NoDob`}
                        style={{ fontSize: 20 }}
                        formData={props.formData}
                      />
                    </Column>
                  )}
                </>
              )}
            </FormRow>

            <ShouldRenderField name={`householdMember${i}SocialItin`} vs={schema}>
              <FormRow>
                <Select
                  width={5}
                  label="Citizen and Immigration Status Information"
                  name={`householdMember${i}CitizenIdType`}
                  formData={props.formData}
                  options={[
                    { value: "ssn_number", label: "Social Security Number" },
                    { value: "itin_number", label: "Tax Identification Number (ITIN)" },
                    { value: "ssn_itin_pending", label: "SSN ITIN Pending" },
                    { value: "ssn_provide_later", label: "I will provide this later" },
                    { value: "not_applicable", label: "I don't have a social security number or ITIN" },
                  ]}
                  onChangeAction={(_selector: any, e: any) => {
                    setState((oldState: any) => ({
                      ...oldState,
                      [`householdMember${i}CitizenIdType`]: e.target.value,
                    }));
                  }}
                />

                {state[`householdMember${i}CitizenIdType`] === "ssn_number" && (
                  <Column width={5}>
                    <Input
                      type="ssn"
                      label="Social Security Number"
                      name={`householdMember${i}Social`}
                      formData={props.formData}
                    />
                  </Column>
                )}

                {state[`householdMember${i}CitizenIdType`] === "itin_number" && (
                  <Column width={5}>
                    <Input
                      type="ssn"
                      label="Tax Identification Number"
                      name={`householdMember${i}TaxIdNumber`}
                      formData={props.formData}
                    />
                  </Column>
                )}

                {state[`householdMember${i}CitizenIdType`] === "ssn_itin_pending" && (
                  <>
                    <Select
                      width={3}
                      label="Document Type"
                      name={`householdMember${i}SsnItinPendingType`}
                      formData={props.formData}
                      options={["SSN", "ITIN"]}
                    />
                    <Column width={3}>
                      <InputDatePicker
                        label="Expected Date Received"
                        placeholder="MM/DD/YYYY"
                        name={`householdMember${i}SsnItinPendingExpectedDate`}
                        formData={props.formData}
                      />
                    </Column>
                  </>
                )}
              </FormRow>
            </ShouldRenderField>

            {isFieldInSchema(`householdMember${i}PrimaryPhone`, validationSchema) && (
              <FormRow>
                <Column width={4}>
                  <Input
                    label="Household Member Phone"
                    name={`householdMember${i}PrimaryPhone`}
                    type="phone_number"
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Household member does not have a phone number"
                    name={`householdMember${i}NoPrimaryPhone`}
                    formData={props.formData}
                  />
                </Column>
                <Select
                  width={3}
                  label="Phone Type"
                  name={`householdMember${i}PrimaryPhoneType`}
                  formData={props.formData}
                  options={["mobile", "landline"]}
                />
                <Column width={3}>
                  <FormLabel>Ok to leave messages?</FormLabel>
                  <RadioYesNoSmall
                    name={`householdMember${i}PrimaryPhoneOkToLeaveMessage`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            )}

            {isFieldInSchema(`householdMember${i}SecondaryPhone`, validationSchema) &&
                i === 0 && ( // primary applicant
              <FormRow>
                <Column width={4}>
                  <Input
                    label="Alternative Applicant Phone"
                    name={`householdMember${i}SecondaryPhone`}
                    type="phone_number"
                    formData={props.formData}
                  />
                  <Typography>
                    <i>
                          Only use contact information for yourself. Additional contacts such as a
                          social worker can be added later in the application.
                    </i>
                  </Typography>
                </Column>
                <Column width={2}>
                  <Input
                    label="Extension"
                    name={`householdMember${i}SecondaryPhoneExt`}
                    formData={props.formData}
                  />
                </Column>
                <Select
                  width={3}
                  label="Phone Type"
                  name={`householdMember${i}SecondaryPhoneType`}
                  formData={props.formData}
                  options={["mobile", "landline"]}
                />
                <Column width={3}>
                  <FormLabel>Ok to leave messages?</FormLabel>
                  <RadioYesNoSmall
                    name={`householdMember${i}SecondaryPhoneOkToLeaveMessage`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            )}

            {isFieldInSchema(`householdMember${i}Email`, validationSchema) && (
              <FormRow>
                <Column width={6}>
                  <Input
                    label="Email Address"
                    type="email"
                    name={`householdMember${i}Email`}
                    formData={props.formData}
                    autoComplete={`householdMember${i}Email`}
                  />
                  <Checkbox
                    label="Household member does not have an email address"
                    name={`householdMember${i}NoEmail`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            )}

            {isFieldInSchema("applicantPreferedContactType", validationSchema) &&
                i === 0 && ( // primary applicant
              <FormRow>
                <RadioGroupBasic
                  label="Do you prefer to communicate via email or mail?"
                  name="applicantPreferedContactType"
                  row
                  options={[
                    { label: "Mail", value: "mail" },
                    { label: "Email", value: "email" },
                  ]}
                  defaultValue={formData.applicantPreferedContactType}
                />
              </FormRow>
            )}

            {isFieldInSchema(`householdMember${i}StudentType`, validationSchema) && (
              <FormRow>
                <RadioGroupBasic
                  label="Is this household member a student?"
                  name={`householdMember${i}StudentType`}
                  row
                  options={[
                    { label: "Full-time", value: "full-time" },
                    { label: "Part-time", value: "part-time" },
                    { label: "No", value: "no" },
                  ]}
                  defaultValue={props.formData[`householdMember${i}StudentType`]}
                />
              </FormRow>
            )}
          </div>
        ))}
        <FormRow style={{ padding: 4 }}><Typography variant="h6" id="address">Address</Typography></FormRow>
        {isFieldInSchema("residenceAddress1", validationSchema) && (
          <div>
            <AddressGroup
              namespace="residence"
              addressLabel="Current Residence Address"
              formData={props.formData}
            />

            <FormRow>
              <Column width={12}>
                <RadioGroupBasic
                  name="mailingAddressType"
                  label="Where do you want to receive mail from us?"
                  options={[
                    { label: "My residence address from above", value: "residence" },
                    { label: "A different address", value: "mailing" },
                  ]}
                  defaultValue={props.formData.mailingAddressType}
                  onChangeAction={(e: any) => {
                    setState((oldState: any) => ({ ...oldState,
                      mailingAddressType: e.value }));
                  }}
                />
              </Column>
            </FormRow>

            <div className={state.mailingAddressType === "mailing" ? "collapse.show" : "collapse"}>
              <AddressGroup
                namespace="mailing"
                addressLabel="Mailing Address"
                formData={props.formData}
              />
            </div>
          </div>
        )}
        <FormRow><Typography variant="h6" id="income">Income Info</Typography></FormRow>

        <ShouldRenderField name="householdGrossAnnualIncome" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Household Total Gross Annual Income"
                name="householdGrossAnnualIncome"
                type="currency_usd"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsEmployed" vs={schema}>
          <RadioYesNo
            label="Are you or anyone who will be living with you employed?"
            name="householdIsEmployed"
            formData={props.formData}
          />
        </ShouldRenderField>

        <ShouldRenderField name="householdIsSelfEmployed" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you self-employed?"
              name="householdIsSelfEmployed"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingUnemployment" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving unemployment benefits?"
              name="householdIsReceivingUnemployment"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingVetIncome" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving Veteran's Administration, GI Bill, or National Guard/Military benefits/income?"
              name="householdIsReceivingVetIncome"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingSocialSecurity" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving social security payments?"
              name="householdIsReceivingSocialSecurity"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingGifts" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving cash contributions of gifts including rent or utility payments, on an ongoing basis from persons not living with you?"
              name="householdIsReceivingGifts"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingSsi" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving periodic Supplemental Security Income (SSI)?"
              name="householdIsReceivingSsi"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingDisabilityBenefits" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving disability or death benefits other than Social Security?"
              name="householdIsReceivingDisabilityBenefits"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingPublicAssistanceIncome" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving Public Assistance Income (examples: TANF, AFDC)? "
              name="householdIsReceivingPublicAssistanceIncome"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsEntitledToChildSupport" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone else who will be living with you entitled to receive child support payments? "
              name="householdIsEntitledToChildSupport"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingChildSupport" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you currently receiving child support payments?"
              name="householdIsReceivingChildSupport"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingAlimony" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving alimony/spousal support payments?"
              name="householdIsReceivingAlimony"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingPeriodicPayments" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving periodic payments from trusts, annuities, inheritance, retirement funds or pensions, insurance policies, or lottery winnings?"
              name="householdIsReceivingPeriodicPayments"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingPropertyIncome" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving income from real or personal property? "
              name="householdIsReceivingPropertyIncome"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingNonLoanFinancialAid" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving student financial aid (public or private, not including student loans)?"
              name="householdIsReceivingNonLoanFinancialAid"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingWorkersComp" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you receive Worker’s Compensation Payments?"
              name="householdIsReceivingWorkersComp"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="householdIsReceivingIncomeNotListed" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have any source of income not listed above?"
              name="householdIsReceivingIncomeNotListed"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <FormRow><Typography variant="h6" id="assets">Asset Info</Typography></FormRow>

        <ShouldRenderField name="householdHasCheckingAccount" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a checking account?"
              name="householdHasCheckingAccount"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i}>
                {[0, 1, 2].map((j) => {
                  const fieldIsVisable = state[`householdMember${i}CheckingInc`] >= j;
                  const isFilled = !!formData[`householdMember${i}Checking${j}BankName`];
                  if (fieldIsVisable || isFilled) {
                    return (
                      <div key={j}>
                        <FormRow style={{ marginTop: 0 }}>
                          <Column width={7}>
                            <ShouldRenderField
                              name={`householdMember${i}Checking${j}BankName`}
                              vs={schema}
                            >
                              <Input
                                label={`Household member ${i + 1} Bank Name #${j + 1}`}
                                name={`householdMember${i}Checking${j}BankName`}
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <FormRow>
                          <Column width={4}>
                            <ShouldRenderField
                              name={`householdMember${i}Checking${j}Balance`}
                              vs={schema}
                            >
                              <Input
                                label={`Total Checking Account Balance #${j + 1}`}
                                name={`householdMember${i}Checking${j}Balance`}
                                type="currency_usd"
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <ShouldRenderField
                          name={`householdMember${i}Checking${j}IsJointAccount`}
                          vs={schema}
                        >
                          <FormRow>
                            <Column width={3}>
                              <FormLabel>Is this a joint account?</FormLabel>
                              <RadioYesNoSmall
                                name={`householdMember${i}Checking${j}IsJointAccount`}
                                formData={props.formData}
                              />
                            </Column>
                            <Column width={4} style={{ margin: "7px  0 0 -35px" }}>
                              <Typography variant="body2">If yes, do not add the same account under a different name.</Typography>
                            </Column>
                          </FormRow>
                        </ShouldRenderField>
                        {formData[`householdMember${i}Checking${j}IsJointAccount`] && (
                          <FormRow>
                            <Typography variant="body2">Who else is listed on the account?</Typography>
                            <Column width={7}>
                              <Input
                                label={`Joint Account Holder Name #${j + 1}`}
                                name={
                                  `householdMember${i}Checking${j}JointAccountHolderName`}
                                formData={props.formData}
                              />
                            </Column>
                          </FormRow>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
                <ShouldRenderField name={`householdMember${i}Checking1Balance`} vs={schema}>
                  <FormRow>
                    <Column width={12}>
                      {state[`householdMember${i}CheckingInc`] < 2 && (
                        <button
                          type="button"
                          className="btn btn-small btn-primary"
                          onClick={() => {
                            const fieldName = `householdMember${i}CheckingInc`;
                            setState((oldState: any) => ({
                              ...oldState,
                              [fieldName]: state[fieldName] + 1,
                            }));
                          }}
                        >
                          Add Another Checking Account
                        </button>
                      )}
                      <hr />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasSavingsAccount" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a savings account?"
              name="householdHasSavingsAccount"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i}>
                {[0, 1, 2].map((j) => {
                  const fieldIsVisable = state[`householdMember${i}SavingsInc`] >= j;
                  const isFilled = !!formData[`householdMember${i}Savings${j}BankName`];
                  if (fieldIsVisable || isFilled) {
                    return (
                      <div key={j}>
                        <FormRow style={{ marginTop: 0 }}>
                          <Column width={7}>
                            <ShouldRenderField
                              name={`householdMember${i}Savings${j}BankName`}
                              vs={schema}
                            >
                              <Input
                                label={`Household member ${i + 1} Bank Name #${j + 1}`}
                                name={`householdMember${i}Savings${j}BankName`}
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <FormRow>
                          <Column width={4}>
                            <ShouldRenderField
                              name={`householdMember${i}Savings${j}Balance`}
                              vs={schema}
                            >
                              <Input
                                label={`Total Savings Account Balance #${j + 1}`}
                                name={`householdMember${i}Savings${j}Balance`}
                                type="currency_usd"
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <ShouldRenderField
                          name={`householdMember${i}Savings${j}IsJointAccount`}
                          vs={schema}
                        >
                          <FormRow>
                            <Column width={3}>
                              <FormLabel>Is this a joint account?</FormLabel>
                              <RadioYesNoSmall
                                name={`householdMember${i}Savings${j}IsJointAccount`}
                                persistTableName="interests"
                                formData={props.formData}
                              />
                            </Column>
                            <Column width={4}>
                              <Typography variant="body2">If yes, do not add the same account under a different name.</Typography>
                            </Column>
                          </FormRow>
                        </ShouldRenderField>
                        {formData[`householdMember${i}Savings${j}IsJointAccount`] && (
                          <FormRow>
                            <Typography variant="body2">Who else is listed on the account?</Typography>
                            <Column width={7}>
                              <Input
                                label={`Joint Account Holder Name #${j + 1}`}
                                name={
                                  `householdMember${i}Savings${j}JointAccountHolderName`}
                                formData={props.formData}
                                persistTableName="interests"
                                validationSchema={validationSchema}
                              />
                            </Column>
                          </FormRow>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
                <ShouldRenderField name={`householdMember${i}Savings1Balance`} vs={schema}>
                  <FormRow>
                    <Column width={12}>
                      {state[`householdMember${i}SavingsInc`] < 2 && (
                        <button
                          type="button"
                          className="btn btn-small btn-primary"
                          onClick={() => {
                            const fieldName = `householdMember${i}SavingsInc`;
                            setState((oldState: any) => ({
                              ...oldState,
                              [fieldName]: state[fieldName] + 1,
                            }));
                          }}
                        >
                          Add Another Savings Account
                        </button>
                      )}
                      <hr />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasRevokTrust" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a revocable trust?"
              name="householdHasRevokTrust"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField name={`householdMember${i}RevokTrustValue`} vs={schema}>
                    <Input
                      key={i}
                      type="currency_usd"
                      label={`Household member ${i + 1} Revocable Trust Value`}
                      name={`householdMember${i}RevokTrustValue`}
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasRealEstate" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you own real estate? "
              name="householdHasRealEstate"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField name={`householdMember${i}RealEstateValue`} vs={schema}>
                    <Input
                      key={i}
                      type="currency_usd"
                      label={`Household member ${i + 1} Real Estate Value`}
                      name={`householdMember${i}RealEstateValue`}
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasStocksTreasuries" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you own stocks, bonds, or Treasury Bills?"
              name="householdHasStocksTreasuries"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i} style={{ marginBottom: 20 }}>
                <Column width={6}>
                  <ShouldRenderField
                    name={`householdMember${i}StockBondTreasuryValue`} vs={schema}>
                    <Input
                      label={`Household member ${i + 1} Stock / Bond / Treasury Bond Value`}
                      name={`householdMember${i}StockBondTreasuryValue`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                  <ShouldRenderField name={`householdMember${i}BrokerageName`} vs={schema}>
                    <Input
                      label="Brokerage Name"
                      name={`householdMember${i}BrokerageName`}
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasCdMoneyMarket" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have Certificate of Deposits (CDs) or a Money Market Account?"
              name="householdHasCdMoneyMarket"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i} style={{ marginBottom: 0 }}>
                <FormRow style={{ marginTop: 10 }}>
                  <Column width={7}>
                    <ShouldRenderField
                      name={`householdMember${i}CdMoneyMarketBankName`}
                      vs={schema}
                    >
                      <Input
                        label={`$Household member ${i + 1} Bank Name`}
                        name={`householdMember${i}CdMoneyMarketBankName`}
                        formData={props.formData}
                      />
                    </ShouldRenderField>
                  </Column>
                </FormRow>
                <FormRow>
                  <Column width={4}>
                    <ShouldRenderField
                      name={`householdMember${i}CdMoneyMarketValue`} vs={schema}>
                      <Input
                        label="CD / Money Market Account Value"
                        name={`householdMember${i}CdMoneyMarketValue`}
                        type="currency_usd"
                        formData={props.formData}
                      />
                    </ShouldRenderField>
                  </Column>
                </FormRow>

                <ShouldRenderField
                  name={`householdMember${i}CdMoneyMarketIsJointAccount`}
                  vs={schema}
                >
                  <div>
                    <FormRow>
                      <Column width={3}>
                        <FormLabel>Is this a joint account?</FormLabel>
                        <RadioYesNoSmall
                          name={`householdMember${i}CdMoneyMarketIsJointAccount`}
                          formData={props.formData}
                        />
                      </Column>
                      <Column width={4} style={{ margin: "7px  0 0 -35px" }}>
                        <Typography variant="body2">If yes, do not add the same account under a different name.</Typography>
                      </Column>
                    </FormRow>
                    {formData[`householdMember${i}CdMoneyMarketIsJointAccount`] && (
                      <FormRow>
                        <Typography variant="body2">Who else is listed on the account?</Typography>
                        <Column width={7}>
                          <Input
                            label="Joint Account Holder Name"
                            name={`householdMember${i}CdMoneyMarketJointAccountHolderName`}
                            formData={props.formData}
                          />
                        </Column>
                      </FormRow>
                    )}
                  </div>
                </ShouldRenderField>
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasIra401kLumpPension" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a IRA/Lump Sum Pension/Keogh Account/401K?"
              name="householdHasIra401kLumpPension"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i} style={{ marginBottom: 0 }}>
                <ShouldRenderField
                  name={`householdMember${i}Ira401kLumpPensionBankName`}
                  vs={schema}
                >
                  <FormRow style={{ marginTop: 10 }}>
                    <Column width={7}>
                      <Input
                        label={`Household member ${i + 1} Bank Name`}
                        name={`householdMember${i}Ira401kLumpPensionBankName`}
                        formData={props.formData}
                      />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
                <ShouldRenderField
                  name={`householdMember${i}Ira401kLumpPensionBalance`}
                  vs={schema}
                >
                  <FormRow>
                    <Column width={4}>
                      <Input
                        label="IRA / Pension / Keogh / 401k Value"
                        name={`householdMember${i}Ira401kLumpPensionBalance`}
                        type="currency_usd"
                        formData={props.formData}
                      />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
                <ShouldRenderField
                  name={`householdMember${i}Ira401kLumpPensionIsJointAccount`}
                  vs={schema}
                >
                  <FormRow>
                    <Column width={3}>
                      <FormLabel>Is this a joint account?</FormLabel>
                      <RadioYesNoSmall
                        name={`householdMember${i}Ira401kLumpPensionIsJointAccount`}
                        persistTableName="interests"
                        formData={props.formData}
                      />
                    </Column>
                    <Column width={4} style={{ margin: "7px  0 0 -35px" }}>
                      <Typography variant="body2">If yes, do not add the same account under a different name.</Typography>
                    </Column>
                  </FormRow>
                </ShouldRenderField>
                {formData[`householdMember${i}Ira401kLumpPensionIsJointAccount`] && (
                  <FormRow>
                    <Typography variant="body2">Who else is listed on the account?</Typography>
                    <Column width={7}>
                      <Input
                        label="Joint Account Holder Name"
                        name={
                          `householdMember${i}Ira401kLumpPensionJointAccountHolderName`}
                        formData={props.formData}
                      />
                    </Column>
                  </FormRow>
                )}
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasWholeLifePolicy" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a whole life insurance policy?"
              name="householdHasWholeLifePolicy"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField
                    name={`householdMember${i}WholeLifeInsuranceValue`}
                    vs={schema}
                  >
                    <Input
                      key={i}
                      label={`Household member ${i + 1} Whole Life Insurance Value`}
                      name={`householdMember${i}WholeLifeInsuranceValue`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasCash" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have cash on hand? "
              name="householdHasCash"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField name={`householdMember${i}CashValue`} vs={schema}>
                    <Input
                      key={i}
                      label={`Household member ${i + 1} Cash on Hand Value`}
                      name={`householdMember${i}CashValue`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasDisposedOfAssets" vs={schema}>
          <div>
            <RadioYesNo
              label="Have you or anyone else who will be living with you disposed of assets (i.e. gave away money/assets) for less than the fair market value in the past 2 years? (Do not include furniture or cars) "
              name="householdHasDisposedOfAssets"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField
                    name={`householdMember${i}DisposedAssetsValue`} vs={schema}>
                    <Input
                      key={i}
                      label={`Household member ${i + 1} Disposed Assets Value`}
                      name={`householdMember${i}DisposedAssetsValue`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="householdHasAssetsNotListed" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have any source of assets not listed above?"
              name="householdHasAssetsNotListed"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                {[0, 1, 2].map((j) => {
                  const fieldIsVisable = state[`householdMember${i}AssetNotlistInc`] >= j;
                  const isFilled = !!formData[`householdMember${i}AssetsNotListed${j}Value`];
                  if (fieldIsVisable || isFilled) {
                    return (
                      <div key={j}>
                        <ShouldRenderField
                          name={`householdMember${i}AssetsNotListed${j}Source`}
                          vs={schema}
                        >
                          <div>
                            <Column width={6}>
                              <Input
                                label={`Household member ${i + 1} Asset #${j + 1} Source`}
                                name={`householdMember${i}AssetsNotListed${j}Source`}
                                formData={props.formData}
                              />
                            </Column>
                            <Column width={6}>
                              <Input
                                type="currency_usd"
                                label="Asset Value"
                                name={`householdMember${i}AssetsNotListed${j}Value`}
                                formData={props.formData}
                              />
                            </Column>
                          </div>
                        </ShouldRenderField>
                      </div>
                    );
                  }
                  return null;
                })}

                <ShouldRenderField
                  name={`householdMember${i}AssetsNotListed0Source`} vs={schema}>
                  <Column width={12}>
                    {state[`householdMember${i}AssetNotlistInc`] < 2 && (
                      <button
                        type="button"
                        className="btn btn-small btn-primary"
                        onClick={() => {
                          const fieldName = `householdMember${i}AssetNotlistInc`;
                          setState((oldState: any) => ({
                            ...oldState,
                            [fieldName]: state[fieldName] + 1,
                          }));
                        }}
                      >
                        Add Another Asset
                      </button>
                    )}
                  </Column>
                </ShouldRenderField>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <FormRow><Typography variant="h6" id="housing">Housing Info</Typography></FormRow>
        <ShouldRenderField name="applicantHomelessDoesNotHaveLandlord" vs={schema}>
          <FormRow>
            <Column width={12}>
              <Checkbox
                label="I am homeless and do not have a landlord "
                name="applicantHomelessDoesNotHaveLandlord"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <FormRow>
          <ShouldRenderField name="landlordFirstName" vs={schema}>
            <Column width={6}>
              <Input
                label="Landlord First Name"
                name="landlordFirstName"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
          <ShouldRenderField name="landlordLastName" vs={schema}>
            <Column width={6}>
              <Input
                label="Landlord Last Name"
                name="landlordLastName"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
        </FormRow>
        <FormRow>
          <ShouldRenderField name="landlordHasUnknownAddress" vs={schema}>
            <Column width={12}>
              <Checkbox
                label="I don’t know my landlord’s address"
                name="landlordHasUnknownAddress"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
        </FormRow>
        <ShouldRenderField name="landlordAddress1" vs={schema}>
          <AddressGroup
            namespace="landlord"
            addressLabel="Landlord Address"
            formData={props.formData}
          />
        </ShouldRenderField>
        <ShouldRenderField name="landlordPrimaryPhone" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Landlord Telephone"
                name="landlordPrimaryPhone"
                formData={props.formData}
                type="phone_number"
              />
            </Column>
            <Select
              width={3}
              label="Phone Type"
              name="landlordPrimaryPhoneType"
              options={["landline", "mobile", "other"]}
              formData={props.formData}
            />

            <Column width={3}>
              <FormLabel>Ok to leave messages?</FormLabel>
              <RadioYesNoSmall name="landlordOkToLeaveMessage" formData={props.formData} />
            </Column>

            <Column width={12}>
              <Checkbox
                label="I don’t know my landlord’s phone number or she/he does not have a phone number"
                name="landlordHasUnknownPhone"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="landlordEmail" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input label="Landlord Email" name="landlordEmail" formData={props.formData} />
            </Column>
            <Select
              width={3}
              label="Reason for Moving"
              name="reasonForMoving"
              options={[
                "Want more space",
                "Rent too high",
                "Family Size Change",
                "Living with Family",
                "Bad Housing conditions",
                "Health Reasons",
                "Homeless",
                "New job",
                "Do not like neighborhood",
                "Other",
              ]}
              formData={props.formData}
            />
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="applicantTotalMonthlyRent" vs={schema}>
          <FormRow>
            <Column width={3}>
              <Input
                label="Total Monthly Rent"
                name="applicantTotalMonthlyRent"
                formData={props.formData}
              />
            </Column>
            <Column width={3}>
              <FormLabel style={{ fontSize: 13, margin: "4px 0 9px 0" }}>Is rent subsidized?</FormLabel>
              <RadioYesNoSmall name="isRentSubsidized" formData={props.formData} />
            </Column>
            <Column width={3}>
              <Input
                label="Your contribution to Rent"
                name="applicantContributionToRent"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <FormRow><Typography variant="h6" id="contact">Optional Contact</Typography></FormRow>
        <ShouldRenderField name="contactDenyInformation" vs={schema}>
          <FormRow>
            <Column width={12}>
              <Checkbox
                label="Check this box if you choose not to provide this information"
                name="contactDenyInformation"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <FormRow>
          <ShouldRenderField name="contactName" vs={schema}>
            <Column width={8}>
              <Input
                label="Name of Additional Contact Person or Organization"
                name="contactName"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
          <ShouldRenderField name="contactRelation" vs={schema}>
            <Select
              width={4}
              label="Optional Contact Type"
              name="contactRelation"
              options={[
                { value: "friend", label: "Friend" },
                { value: "family_member", label: "Family Member" },
                { value: "case_manager", label: "Case Manager or Housing Counselor" },
                { value: "other", label: "Other" },
                { value: "I don't have an alternate contact", label: "I don't have an alternate contact" },
              ]}
              formData={props.formData}
            />
          </ShouldRenderField>
        </FormRow>
        <ShouldRenderField name="contactAddress1" vs={schema}>
          <AddressGroup
            namespace="contact"
            addressLabel="Contact Address"
            formData={props.formData}
          />
        </ShouldRenderField>
        <ShouldRenderField name="contactPrimaryPhone" vs={schema}>
          <FormRow>
            <Column width={4}>
              <Input
                label="Optional Contact Phone Number"
                name="contactPrimaryPhone"
                type="phone_number"
                formData={props.formData}
              />
            </Column>
            <Column width={2}>
              <Input label="Extension" name="contactPrimaryPhoneExt" formData={props.formData} />
            </Column>
            <Select
              width={3}
              label="Phone Type"
              name="contactPrimaryPhoneType"
              options={["landline", "mobile", "other"]}
              formData={props.formData}
            />
            <Column width={3}>
              <FormLabel>Ok to leave messages?</FormLabel>
              <RadioYesNoSmall
                name="contactPrimaryPhoneOkToLeaveMessage"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="contactSecondaryPhone" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Additional Optional Contact Phone Number"
                name="contactSecondaryPhone"
                type="phone_number"
                formData={props.formData}
              />
            </Column>
            <Select
              width={3}
              label="Phone Type"
              name="contactSecondaryPhoneType"
              options={["landline", "mobile", "other"]}
              formData={props.formData}
            />
            <Column width={3}>
              <FormLabel>Ok to leave messages?</FormLabel>
              <RadioYesNoSmall
                name="contactSecondaryPhoneOkToLeaveMessage"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="contactEmail" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Optional Contact Email"
                name="contactEmail"
                type="email"
                formData={props.formData}
                autoComplete="contactEmail"
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="contactReasons" vs={schema}>
          <FormRow style={{ paddingBottom: 20 }}>
            <Column width={6}>
              <FormLabel style={{ fontSize: 13, margin: "5px 0px 10px 8px" }}>
                Reason for Contact (check all that apply):
              </FormLabel>
              <Checkbox
                label="Send application receipt & inform about waitlist updates"
                name="contactReasonReceipt"
                formData={props.formData}
              />
              <Checkbox
                label="Emergency"
                name="contactReasonEmergency"
                formData={props.formData}
              />
              <Checkbox
                label="Unable to contact you"
                name="contactReasonUnableToContact"
                formData={props.formData}
              />
              <Checkbox
                label="Termination of rental assistance"
                name="contactReasonTerminationOfRentalAssist"
                formData={props.formData}
              />
              <Checkbox
                label="Eviction from unit"
                name="contactReasonEvictionFromUnit"
                formData={props.formData}
              />
              <Checkbox
                label="Late payment of rent"
                name="contactReasonLatePaymentOfRent"
                formData={props.formData}
              />
              <Checkbox
                label="Assist with Recertification"
                name="contactReasonAssistWithRecertification"
                formData={props.formData}
              />
              <Checkbox
                label="Change in lease terms"
                name="contactReasonChangeInLeaseTerms"
                formData={props.formData}
              />
              <Checkbox
                label="Change in house rules"
                name="contactReasonChangeInHouseRules"
                formData={props.formData}
              />
              <Checkbox label="Other" name="contactReasonOther" formData={props.formData} />
            </Column>
            <div style={{ height: 15 }} />
          </FormRow>
        </ShouldRenderField>
        <FormRow><Typography variant="h6" id="race">Race and Ethnicity</Typography></FormRow>
        {members.map((member, i) => (
          <ShouldRenderField name={`householdMember${i}EthnicCategory`} vs={schema} key={i}>
            <div>
              <Typography variant="body2">Household member: {member.name}</Typography>
              <FormRow>
                <Column width={12}>
                  <RadioGroupBasic
                    label="Ethnic Category"
                    name={`householdMember${i}EthnicCategory`}
                    options={[
                      { label: "Hispanic", value: "Hispanic or Latino" },
                      { label: "Non-Hispanic", value: "Not-Hispanic or Latino" },
                    ]}
                    defaultValue={props.formData[`householdMember${i}EthnicCategory`]}
                  />
                </Column>
              </FormRow>

              <FormLabel style={{ fontSize: 12 }}>
                Racial Categories (check all that apply):
              </FormLabel>
              <FormRow>
                <Column width={12}>
                  <Checkbox
                    label="American Indian or Alaskan Native"
                    name={`householdMember${i}RaceAmerIndianAlaskanNative`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Asian"
                    name={`householdMember${i}RaceAsian`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Black or African American"
                    name={`householdMember${i}RaceAfricanAmerican`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Native Hawaiian or other Pacific Islander"
                    name={`householdMember${i}RaceNativeHawaiianOrOtherPacIslander`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="White"
                    name={`householdMember${i}RaceWhite`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Other"
                    name={`householdMember${i}RaceOther`}
                    formData={props.formData}
                  />
                  <br />
                  <Checkbox
                    label="I choose not to provide this information"
                    name={`householdMember${i}RaceDecline`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            </div>
          </ShouldRenderField>
        ))}
        <div>
          <FormRow><Typography variant="h6" id="additional">Additional Info</Typography></FormRow>

          <div>
            <FormLabel style={{ marginBottom: 1 }}>Which ways can we contact you?</FormLabel>
            <FormRow>
              <Column width={12}>
                <Checkbox
                  inline
                  label="Phone"
                  name="contactMethodPhone"
                  formData={props.formData}
                />
                <Checkbox
                  inline
                  label="Text"
                  name="contactMethodSms"
                  formData={props.formData}
                />
                <Checkbox
                  inline
                  label="Email"
                  name="contactMethodEmail"
                  formData={props.formData}
                />
                <Checkbox
                  inline
                  label="Mail"
                  name="contactMethodMail"
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </div>

          <ShouldRenderField name="prefMoveInDate" vs={schema}>
            <FormRow style={{ marginTop: -10 }}>
              <Column width={8}>
                <InputDatePicker
                  label="Preferred Move-In Date"
                  placeholder="MM/DD/YYYY"
                  name="prefMoveInDate"
                  width={5}
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="unitSize" vs={schema}>
            <FormRow>
              <RadioGroupBasic
                name="unitSize"
                label="Unit Sizes"
                options={getUnitSizeOptions(schema).map(({ label, value }) => ({
                  label,
                  value,
                }))}
                defaultValue={
                  props.formData.unitSize?.toLowerCase() ??
                  getUnitSizeOptions(schema).find(
                    ({ value }) => props.formData[`unitSize${capitalize(value)}`] === true,
                  )?.value
                }
              />
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="unitSizeGroup" vs={schema}>
            <div>
              <FormLabel style={{ marginBottom: 1 }}>What size unit do you want?</FormLabel>
              <FormRow>
                <Column width={12}>
                  {unitSizeMetadata.map(({ id, label }) => ({ id, label, name: `unitSize${id}` }))
                    .map(({ id, label, name }) => (
                      <ShouldRenderField key={name} name={name} vs={schema}>
                        <Checkbox
                          label={label}
                          name={name}
                          formData={props.formData}
                          defaultChecked={
                            props.formData[name] ||
                          (props.formData.unitSize || "").split(",").includes(id.toLowerCase())}
                        />
                      </ShouldRenderField>))}
                </Column>
              </FormRow>
            </div>
          </ShouldRenderField>
          <ShouldRenderField name="householdLivesWorksInAlameda" vs={schema}>
            <RadioYesNo
              label="Do you work OR live in the City of Alameda, or have at least one adult member who lives or works in the City of Alameda?"
              name="householdLivesWorksInAlameda"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdLivesWorksInSanCarlos" vs={schema}>
            <RadioYesNo
              label="Does anyone in the household currently live or work in San Carlos?"
              name="householdLivesWorksInSanCarlos"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdHasHousingAuthorityVoucher" vs={schema}>
            <RadioYesNo
              label="Do you or anyone you plan to have living with you currently have a Rental Voucher from a Housing Authority (such as Section 8)?"
              name="householdHasHousingAuthorityVoucher"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdReceivesOtherHousingAssistance" vs={schema}>
            <RadioYesNo
              label="Do you or anyone you plan to have living with you currently receive any housing assistance program OTHER than Section 8?"
              name="householdReceivesOtherHousingAssistance"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdReceivesOtherHousingAssistanceSubsidyType" vs={schema}>
            <FormRow style={{ marginTop: -10 }}>
              <Column width={6}>
                <Input
                  label="Subsidy Type"
                  name="householdReceivesOtherHousingAssistanceSubsidyType"
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="applicantEmployeeOfNyc" vs={schema}>
            <RadioYesNo
              label="Are you an employee of the City of New York, the New York City Housing Development Corporation, the New York City Department of Housing Preservation and Development, the New York City Economic Development Corporation, the New York City Housing Authority, or the New York City Health and Hospitals Corporation?"
              name="applicantEmployeeOfNyc"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="applicantHadNycHousingInvolvement" vs={schema}>
            <RadioYesNo
              label="If yes, have you personally had any role or involvement in any process, decision, or approval regarding the housing development that is the subject of this application?"
              name="applicantHadNycHousingInvolvement"
              formData={props.formData}
            />
          </ShouldRenderField>

          <ShouldRenderField name="householdAllFullTimeStudents" vs={schema}>
            <RadioYesNo
              label="Are all household members full-time students?"
              name="householdAllFullTimeStudents"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdHasPets" vs={schema}>
            <RadioYesNo
              label="Do you have any pets?"
              name="householdHasPets"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdOwnsCar" vs={schema}>
            <RadioYesNo
              label="Do you or anyone in your household own a car?"
              name="householdOwnsCar"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdDisability" vs={schema}>
            <RadioYesNo
              label="Do you or your household have a disability need for a reasonable accommodation or modification?"
              name="householdDisability"
              formData={props.formData}
            />
          </ShouldRenderField>

          <ShouldRenderField name="householdDisabilityAnswer" vs={schema}>
            <FormRow style={{ marginTop: -10 }}>
              <Column width={8}>
                <Input
                  label={getLabelFromSchema(schema, "householdDisabilityAnswer")}
                  name="householdDisabilityAnswer"
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="householdRequiresImpairmentMobility" vs={schema}>
            <RadioYesNo
              label="Do you or anyone who will be living with you require special unit design features for mobility impairment?"
              name="householdRequiresImpairmentMobility"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdRequiresImpairmentVisual" vs={schema}>
            <RadioYesNo
              label="Do you or anyone who will be living with you require special unit design features for visual impairment?"
              name="householdRequiresImpairmentVisual"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdRequiresImpairmentHearing" vs={schema}>
            <RadioYesNo
              label="Do you or anyone who will be living with you require special unit design features for hearing impairment?"
              name="householdRequiresImpairmentHearing"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="householdServedInArmedForces" vs={schema}>
            <RadioYesNo
              label="Has anyone in the household served in the United States Armed Forces?"
              name="householdServedInArmedForces"
              formData={props.formData}
            />
          </ShouldRenderField>

          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((i) => {
            const fieldName = `customPref${i + 1}`;
            const answerFieldName = `customPref${i + 1}Answer`;
            return (
              <div key={i} >
                <ShouldRenderField name={fieldName} vs={schema}>
                  <RadioYesNo
                    label={getLabelFromSchema(schema, fieldName)}
                    name={fieldName}
                    formData={formData}
                  />
                </ShouldRenderField>

                <ShouldRenderField name={answerFieldName} vs={schema}>
                  <FormRow style={{ marginTop: -10 }}>
                    <Column width={8}>
                      <Input
                        label={getLabelFromSchema(schema, answerFieldName)}
                        name={answerFieldName}
                        formData={formData}
                      />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
              </div>
            );
          })}
        </div>

        <ShouldRenderField name="howDidApplicantHearAboutProperty" vs={schema}>
          <FormRow>
            <Select
              label="How / where did you find out about this property?"
              name="howDidApplicantHearAboutProperty"
              width={6}
              formData={props.formData}
              options={[
                "Newspaper",
                "Social Media",
                "Local Organization or Church",
                "Word of Mouth",
                "Affordable Housing Hotline",
                "Posted Sign",
                "Haven Connect",
                "Other",
              ]}
            />
          </FormRow>
        </ShouldRenderField>

        <ShouldRenderField name="extraInfo" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Anything else you’d like us to know about yourself"
                name="extraInfo"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
      </div>
    </>
  );
};
export default InterestForm;
